import { render, staticRenderFns } from "./GoodsListV3Block.vue?vue&type=template&id=9420ec6a&scoped=true"
import script from "./GoodsListV3Block.vue?vue&type=script&lang=js"
export * from "./GoodsListV3Block.vue?vue&type=script&lang=js"
import style0 from "./GoodsListV3Block.vue?vue&type=style&index=0&id=9420ec6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9420ec6a",
  null
  
)

export default component.exports